import { useFormContext } from 'react-hook-form'

import { useAccountVerification } from '@/features/update-account'
import { useRouter } from '@/shared/i18n'
import { Button } from '@/shared/ui'

import { useHostConversion } from '../api/host-conversion'
import { convertFormValuesToSignUpHostConversion } from '../model/converter'
import { useHostConversionCompleteStore } from '../model/host-conversion-complete'
import { TSignUpHostConversionForm } from '../model/host-conversion-form'

export const HostConversionButton = () => {
  const router = useRouter()

  const actions = useHostConversionCompleteStore(state => state.actions)

  const { accountTrigger } = useAccountVerification()

  const { getValues, handleSubmit } =
    useFormContext<TSignUpHostConversionForm>()

  const { hostConversion } = useHostConversion({
    onSuccess: () => {
      actions.updateCompleteTime(new Date().toISOString())

      router.push('/sign-up/host-conversion/complete')
    },
  })

  const handleHostConversion = async () => {
    const isAccountVerificationCompleted = await accountTrigger()

    if (!isAccountVerificationCompleted) {
      return false
    }

    const formValues = getValues()

    const signUpData = convertFormValuesToSignUpHostConversion(formValues)

    hostConversion({ body: signUpData })
  }

  return (
    <Button
      type="button"
      className="mt-10"
      size="large"
      fullWidth
      onClick={handleSubmit(handleHostConversion)}
    >
      완료하기
    </Button>
  )
}
